import { WorkOrderDetail } from "../redux/slices/workOrderDetailSlice";
import { Section } from "../types/inspection";
// import { Image } from "../types/inspection";
import { isPointCompleted } from "./inspectionItems";
// import { isPointCompleted } from "./inspectionItems";

export const calculateTotalVerifiedPoints = (sections: any[]) => {
    let totalVerifiedPoints = 0;
    sections.forEach((section) => {
        section.points.forEach((point: any) => {
            if (point.isCompleted) {
                totalVerifiedPoints++;
            }
        });
    });
    return totalVerifiedPoints;
};

export const calculateTotalVerifiedModules = (modules: any[]) => {
    return modules.reduce((count, module) => {
        const verifiedPoints = module.points.filter((point: any) => point.isCompleted).length;
        return verifiedPoints === module.points.length ? count + 1 : count;
    }, 0);
};

export const processWorkOrders = (workOrders: WorkOrderDetail[]): WorkOrderDetail[] => {
    return workOrders.map((workOrder) => {
        let totalVerifiedModules = 0;
        let totalVerifiedPoints = 0;

        const newSections = workOrder.modules.map((module) => {
            let verifiedCount = 0;

            const details = module.points.map((point: any) => {
                let updatingPoint =
                {
                    ...point,
                    id: point.id,
                    label: point.description,
                    answerValue: point.answerValue,
                    type_ID: point.type_ID,
                    answerDisplay: point?.answerDisplay,
                    verify: point?.verify,
                    // photos: mergePhotos,
                    notApplicable: point.notApplicable,
                    actions: {
                        check: { enabled: point.type_ID === 5 || point.type_ID === 4, isSelected: false },
                        cross: { enabled: point.type_ID === 5 || point.type_ID === 4, isSelected: false },
                        camera: { enabled: point.photoOption_ID == 1 || point.photoOption_ID == 2, isSelected: false },
                        video: { enabled: point.videoOption_ID == 1 ||  point.videoOption_ID == 2, isSelected: false },
                        gallery: { enabled: point.photoOption_ID == 1 || point.photoOption_ID == 2 || point.videoOption_ID == 1 ||  point.videoOption_ID == 2, isSelected: false },
                        comment: { enabled: point.type_ID !== 1 && (point.type_ID !== 6 || point.videoOption_ID !== 1), isSelected: false },
                        trash: { enabled: true, isSelected: false },
                        edit: { enabled: point.type_ID === 1 || point.type_ID === 3, isSelected: false },
                    },

                }
                const isCompleted = isPointCompleted(updatingPoint, workOrder.type);

                if (isCompleted) {
                    verifiedCount++;
                    totalVerifiedPoints++;
                }
                return {
                    ...updatingPoint,
                    isCompleted
                };
            });
            const isModuleVerified = verifiedCount === module.points.length;
            if (isModuleVerified) {
                totalVerifiedModules++;
            }
            const isSkipped = details.every((point: any) => point.notApplicable === true);

            return {
                ...module,
                title: module.inspectionModule,
                total: module.points.length,
                isOpen: false,
                totalVerified: verifiedCount,
                points: details,
                isSkipped
            };
        });

        // Ensure total verified points do not exceed total points
        totalVerifiedPoints = Math.min(totalVerifiedPoints, newSections.reduce((sum, section) => sum + section.total, 0));
        // Ensure total verified modules do not exceed total modules
        totalVerifiedModules = Math.min(totalVerifiedModules, newSections.length);

        const totalSumOfPoints = newSections.reduce((sum, section) => sum + section.total, 0);

        return {
            ...workOrder,
            modules: newSections,
            totalSumOfPoints,
            totalVerifiedModules,
            totalVerified: totalVerifiedPoints,
        };
    });
};

export const processAsset = (asset: any): WorkOrderDetail => {
    let totalVerifiedModules = 0;
    let totalVerifiedPoints = 0;

    const newSections = asset.modules.map((module: any) => {
        let verifiedCount = 0;

        const details = module.points.map((point: any) => {
            let updatingPoint =
            {
                ...point,
                id: point.id,
                label: point.description,
                answerValue: point.answerValue,
                type_ID: point.type_ID,
                answerDisplay: point?.answerDisplay,
                verify: point?.verify,
                // photos: mergePhotos,
                notApplicable: point.notApplicable,
                actions: {
                    check: { enabled: point.type_ID === 5 || point.type_ID === 4, isSelected: false },
                    cross: { enabled: point.type_ID === 5 || point.type_ID === 4, isSelected: false },
                    camera: { enabled: point.photoOption_ID == 1 || point.photoOption_ID == 2, isSelected: false },
                    video: { enabled: point.videoOption_ID == 1 || point.videoOption_ID == 2, isSelected: false },
                    gallery: { enabled: point.photoOption_ID == 1 || point.photoOption_ID == 2 || point.videoOption_ID == 1 || point.videoOption_ID == 2, isSelected: false },
                    comment: { enabled: point.type_ID !== 1 && (point.type_ID !== 6 || point.videoOption_ID !== 1), isSelected: false },
                    trash: { enabled: true, isSelected: false },
                    edit: { enabled: point.type_ID === 1 || point.type_ID === 3, isSelected: false },
                },

            }
            const isCompleted = isPointCompleted(updatingPoint, asset.type);

            if (isCompleted) {
                verifiedCount++;
                totalVerifiedPoints++;
            }
            return {
                ...updatingPoint,
                isCompleted
            };
        });
        const isModuleVerified = verifiedCount === module.points.length;
        if (isModuleVerified) {
            totalVerifiedModules++;
        }
        const isSkipped = details.every((point: any) => point.notApplicable === true);

        return {
            ...module,
            title: module.inspectionModule,
            total: module.points.length,
            isOpen: false,
            totalVerified: verifiedCount,
            points: details,
            isSkipped
        };
    });

    // Ensure total verified points do not exceed total points
    totalVerifiedPoints = Math.min(totalVerifiedPoints, newSections.reduce((sum: number, section: Section) => sum + section.total, 0));
    // Ensure total verified modules do not exceed total modules
    totalVerifiedModules = Math.min(totalVerifiedModules, newSections.length);

    const totalSumOfPoints = newSections.reduce((sum: number, section: Section) => sum + section.total, 0);

    return {
        ...asset,
        modules: newSections,
        totalSumOfPoints,
        totalVerifiedModules,
        totalVerified: totalVerifiedPoints,
    };
};